import { createSlice } from '@reduxjs/toolkit';
import { createContext } from 'react';
// utils
import { ServerConfiguration } from '../../utils/serverConfig';
import { setUser } from '../../auth/utils';

// ----------------------------------------------------------------------

const url = ServerConfiguration.testingServerUrl;

const initialState = {
  isLoading: false,
  error: null,

  programmeList: [],
  programmeAction: null,
  programmeMarking: [],
};

const slice = createSlice({
  name: 'programme',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    
    viewProgrammeSuccess(state, action) {
      state.isLoading = false;
      state.programmeList = action.payload;
    },

    addProgrammeSuccess(state, action) {
      state.isLoading = false;
      state.programmeAction = action.payload;
    },

    viewProgrammeMarkingSuccess(state, action) {
      state.isLoading = false;
      state.programmeMarking = action.payload;
    },

    clearProgrammeSuccess(state, action) {
      state.isLoading = false;
      state.programmeAction = null;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onOpenModal, onCloseModal, selectUser, selectRange, startLoading } = slice.actions;

// ----------------------------------------------------------------------

export const AuthContext = createContext(null);

export function viewProgramme() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(
        `${url}Programme_ViewProgramme?`
      )
      const json = await response.json();
      const data = JSON.parse(json)[0];

      if (data && data.ReturnVal === 1) {
        const programmes = JSON.parse(data.ReturnData);
        dispatch(slice.actions.viewProgrammeSuccess(programmes));
      } else {
        dispatch(slice.actions.viewProgrammeSuccess([]));
        console.error(data.ReturnSqlError);
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function addProgramme(UserID, ProgrammerID, ProgrammerSchemeMark,Year) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(
        `${url}Programme_AddProgrammeMarking?USERID=${UserID}&PROGRAMMERID=${ProgrammerID}&PROGRAMMERSCHEMEMARK=${ProgrammerSchemeMark}&YEAR=${Year}`
      )
    
      const json = await response.json();
      const data = JSON.parse(json)[0];
      if (data && data.ReturnVal === 1) {
        setUser(data.ReturnData)
        dispatch(slice.actions.addProgrammeSuccess(JSON.parse(data.ReturnData)[0]));
      } else {
        dispatch(slice.actions.addProgrammeSuccess(data.ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function viewProgrammeMarking(UserID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(
        `${url}Programme_ViewProgrammeMarking?USERID=${UserID}`
      );

      const json = await response.json();
      const data = JSON.parse(json)[0];
      if (data && data.ReturnVal === 1) {
        dispatch(slice.actions.viewProgrammeMarkingSuccess(JSON.parse(data.ReturnData)));
      } else {
        dispatch(slice.actions.viewProgrammeMarkingSuccess([]));
      }
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function clearProgramme() {
  return async (dispatch) => {
      dispatch(slice.actions.clearProgrammeSuccess());
  };
}